import { getIn } from 'formik';
import { first } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Button, Card, CardBody, CardHeader, Col, Input, InputGroup, InputGroupText, Label, Row, UncontrolledTooltip } from 'reactstrap';
import { adminAPIURL } from '../../../../../../../Config';
import axios from 'axios';
import Select from 'react-select';
import { isValidEmail } from '../../../../../../../Helpers/Helpers';
import cogoToast from 'cogo-toast';
import { Loader } from '../../../../../../../Common';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CAR_TYPE, GET_CAR_TYPE_EMPTY, POST_IMAGE, POST_IMAGE_EMPTY } from '../../../../../../../../store/actions';
import { Trash2 } from 'react-feather';

const getInitialValues = () => {
  return {
    email: '',
    firstName: '',
    lastName: '',
    documentUrl: '',
    region: null,
    currency: null,
    taxMode: null,
    taxValue: '',
    password: '',
    selectedCarTypes: [],
  };
};

const currencyOptions = [
  { label: 'INR', value: 'INR' },
  { label: 'AED', value: 'AED' },
  { label: 'Dollar', value: 'Dollar' },
  { label: 'Euro', value: 'Euro' },
];

const taxModeOptions = [
  { label: 'Vat', value: 'vat' },
  { label: 'Gst', value: 'gst' },
];

const AddVendor = ({ setIsVendorCreate, setState, setFormCount }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [vendor, setVendor] = useState(getInitialValues());
  const [errors, setErrors] = useState<any>({});
  const [isEditable, setIsEditable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [carTypeList, setCarTypeList] = useState([]);
  const [car, setCar] = useState([
    {
      carName: '',
      carType: null,
    },
  ]);
  const [carTypeOptions, setCarTypeOptions] = useState([]);
  const [carErrors, setCarErrors] = useState<any>([{}]);

  const { getCarType, getCarTypeLoading, createUploadTicket } = useSelector((state: any) => ({
    getCarType: state.GetCarType.data,
    getCarTypeLoading: state.GetCarType.loading,

    createUploadTicket: state?.PostImage?.data,
  }));

  useEffect(() => {
    if (createUploadTicket !== null) {
      setVendor(vendor => ({ ...vendor, documentUrl: createUploadTicket?.data }));
      dispatch({ type: POST_IMAGE_EMPTY });
    }
  }, [createUploadTicket]);

  useEffect(() => {
    dispatch({ type: GET_CAR_TYPE });
  }, []);

  useEffect(() => {
    if (vendor?.selectedCarTypes?.length > 0) {
      const options = vendor.selectedCarTypes.map(type => ({
        value: type.id,
        label: type.name,
        data: type,
      }));
      setCarTypeOptions(options);
    }
  }, [vendor?.selectedCarTypes]);

  useEffect(() => {
    if (getCarType !== null) {
      setCarTypeList(getCarType?.data ?? []);
      dispatch({ type: GET_CAR_TYPE_EMPTY });
    }
  }, [getCarType]);

  useEffect(() => {
    if (getCarTypeLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getCarTypeLoading]);

  useEffect(() => {
    setVendor(prev => ({ ...prev, password: generatePassword(10) }));
  }, []);

  const handleChange = (field, value) => {
    switch (field) {
      case 'email':
        if (isEditable) {
          setIsEditable(false);
        }
        break;

      default:
        break;
    }
    setVendor(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: '' }));
  };

  async function loadOptions(search) {
    const response = await axios.get(`${adminAPIURL}/v2/global/regions`, {
      headers: { 'Project-Code': 'ADMIN_ACCESS' },
      params: { search },
      withCredentials: true,
    });

    return {
      options: response?.data?.data?.map(data => ({
        value: data.id,
        label: data.name,
        completeData: data,
      })),
      hasMore: false,
    };
  }

  const onSelectRegion = region => {
    setVendor(prev => ({ ...prev, region }));
  };

  const checkEmailExist = async () => {
    if (!isValidEmail(vendor.email.trim())) {
      setErrors(prev => ({ ...prev, email: 'Please enter correct email format' }));
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(`${adminAPIURL}/v2/vendor/benefit-type/airport-transfer`, {
        params: { search: vendor.email },
        headers: { 'Project-Code': 'ADMIN_ACCESS' },
        withCredentials: true,
      });
      setLoading(false);
      console.log('Vendor Search Response', res?.data?.vendors);
      if (res?.data?.vendors?.length === 0) {
        setIsEditable(true);
        return;
      } else cogoToast.error('Vendor already exists');
    } catch (error) {
      cogoToast.error(error?.message);
      setLoading(false);
    }
  };

  const handleCarTypeClick = type => {
    const isSelected = vendor.selectedCarTypes.some(selected => selected.id === type.id);
    let updatedCarTypes = [];
    if (isSelected) {
      updatedCarTypes = vendor.selectedCarTypes.filter(selected => selected.id !== type.id);
    } else {
      updatedCarTypes = [...vendor.selectedCarTypes, type];
    }
    setVendor(prev => ({ ...prev, selectedCarTypes: updatedCarTypes }));
    setErrors(prev => ({ ...prev, selectedCarTypes: '' }));
  };

  const handleChangeForCar = (index, field, value) => {
    const updatedCar = [...car];
    updatedCar[index][field] = value;
    setCar(updatedCar);

    // Clear error if user fills it
    const updatedErrors: any = [...carErrors];

    if (field === 'carName' && value.trim() !== '') {
      updatedErrors[index].carName = '';
    }
    if (field === 'carType' && value) {
      updatedErrors[index].carType = '';
    }
    setCarErrors(updatedErrors);
  };

  const handleFileUpload = files => {
    const uploadedFile = files[0];
    if (!uploadedFile) return;

    const allowedExtension = 'pdf';
    const maxFileSize = 10 * 1024 * 1024;

    const fileExtension = uploadedFile.name.split('.').pop().toLowerCase();

    if (fileExtension !== allowedExtension) {
      cogoToast.error(`Invalid file type. Only PDF files are allowed.`);
      return;
    }

    if (uploadedFile.size > maxFileSize) {
      cogoToast.error(`File size exceeds the 10MB limit.`);
      return;
    }

    const formData = new FormData();
    formData.append('file', new File([uploadedFile], uploadedFile.name, { type: uploadedFile.type }));

    dispatch({
      type: POST_IMAGE,
      payload: {
        data: formData,
        urlParam: { fileType: 4 },
      },
    });

    setErrors(prev => ({ ...prev, documentUrl: '' }));
  };

  const addNewCarType = () => {
    // Check if any existing car has empty carName or carType
    const hasEmptyFields = car.some(item => !item.carName.trim() || !item.carType);

    if (hasEmptyFields) {
      // Set error messages for all cars
      const updatedErrors = car.map(item => ({
        carName: !item.carName.trim() ? 'Car Name is required' : '',
        carType: !item.carType ? 'Service Type is required' : '',
      }));
      setCarErrors(updatedErrors);
      return; // Do not add new row
    }

    // If validation passes, add new car row
    setCar([
      ...car,
      {
        carName: '',
        carType: null,
      },
    ]);
    setCarErrors([...carErrors, {}]); // Add empty error object for new row
  };

  const removeCarType = index => {
    const updatedCar = [...car];
    const updatedErrors = [...carErrors];
    updatedCar.splice(index, 1);
    updatedErrors.splice(index, 1);
    setCar(updatedCar);
    setCarErrors(updatedErrors);
  };

  const triggerUpload = () => {
    fileInputRef.current?.click();
  };

  const validateForm = () => {
    const newErrors: any = {};

    if (!vendor.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!isValidEmail(vendor.email.trim())) {
      newErrors.email = 'Invalid email format';
    }

    if (!vendor.firstName.trim()) {
      newErrors.firstName = 'First Name is required';
    }

    if (!vendor.lastName.trim()) {
      newErrors.lastName = 'Last Name is required';
    }

    if (!vendor.region) {
      newErrors.region = 'Region is required';
    }

    if (!vendor.currency) {
      newErrors.currency = 'Currency is required';
    }

    if (!vendor.taxMode) {
      newErrors.taxMode = 'Tax Mode is required';
    }

    if (!vendor.taxValue.trim()) {
      newErrors.taxValue = 'Tax Value is required';
    } else {
      const taxNum = Number(vendor.taxValue);
      if (isNaN(taxNum) || taxNum < 1 || taxNum > 100) {
        newErrors.taxValue = 'Tax Value must be between 1 and 100';
      }
    }

    if (!vendor.password.trim()) {
      newErrors.password = 'Password is required';
    }

    if (vendor.selectedCarTypes.length === 0) {
      newErrors.selectedCarTypes = 'Select at least one Car Type';
    }

    // Validate car configuration
    const updatedCarErrors = car.map(item => ({
      carName: !item.carName.trim() ? 'Car Name is required' : '',
      carType: !item.carType ? 'Service Type is required' : '',
    }));

    setCarErrors(updatedCarErrors);

    setErrors(newErrors);

    // return boolean
    return Object.keys(newErrors).length === 0 && updatedCarErrors.every(e => !e.carName && !e.carType);
  };

  const handleSubmit = () => {
    if (!isEditable) {
      cogoToast.error('Please verify email before submitting');
      return;
    }
    if (!validateForm()) {
      cogoToast.error('Please fix validation errors before submitting');
      return;
    }
    setState(prev => ({
      ...prev,
      vendorPricing: {
        ...prev?.vendorPricing,
        vendors: [
          {
            id: Math.random().toString(36).substring(2, 10),
            firstName: vendor?.firstName?.trim() || '',
            lastName: vendor?.lastName?.trim() || '',
            email: vendor?.email || '',
            documentUrl: vendor?.documentUrl || '',
            region: vendor?.region?.label || '',
            currency: vendor?.currency?.value || '',
            carTypes:
              vendor?.selectedCarTypes?.map(carType => {
                const getCarsForCarType = car
                  ?.filter(carItem => carType?.id === carItem?.carType?.value)
                  ?.map(carItem => ({
                    carName: carItem?.carName,
                    tag: 'partially_configured',
                  }));
                return {
                  ...carType,
                  cars: getCarsForCarType || [],
                };
              }) || [],
            taxMode: vendor?.taxMode?.value || '',
            taxValue: convertToNumber(vendor?.taxValue),
            password: vendor?.password?.trim() || '',
            tag: 'partially_configured',
          },
        ],
      },
    }));
    setVendor(getInitialValues());
    setFormCount(prev => prev + 1);
  };

  const convertToNumber = val => {
    if (val === undefined || val === null) return '';
    const num = Number(val);
    return isNaN(num) ? val.toString().trim() : num;
  };

  // Generate Alphanumeric Password
  const generatePassword = (length = 10) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let pwd = '';
    for (let i = 0; i < length; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return pwd;
  };

  return (
    <>
      {loading && <Loader />}

      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h5 className="m-0 fw-semibold">Create Vendor</h5>

          <Button
            className="btn btn-success"
            onClick={() => {
              setIsVendorCreate(prev => !prev);
            }}
            color="primary"
          >
            Vendor List
          </Button>
        </CardHeader>
        <CardBody className="pb-5">
          <Row className="mb-3">
            {/* Email */}
            <Col md={5} className="mb-2">
              <Label for="email">Email</Label>
              <div className="d-flex gap-2 align-items-center">
                <Input
                  type="email"
                  id="email"
                  value={vendor.email}
                  onChange={e => handleChange('email', e.target.value)}
                  placeholder="Enter Email"
                  invalid={!!errors.email}
                  style={{ width: '320px' }}
                />
                <Button
                  style={{ width: '150px' }}
                  color="primary"
                  type="button"
                  onClick={checkEmailExist}
                  disabled={vendor?.email?.trim()?.length === 0}
                >
                  {isEditable ? 'Verified' : 'Verify'}
                </Button>
              </div>
              {errors.email && <div className="text-danger small">{errors.email}</div>}
            </Col>

            {/* Name */}
            <Col md={3} className="mb-2">
              <Label for="firstName">First Name</Label>
              <Input
                type="text"
                id="firstName"
                value={vendor.firstName}
                onChange={e => handleChange('firstName', e.target.value)}
                invalid={!!errors.firstName}
                placeholder="Vendor Name"
                disabled={!isEditable}
              />
              {errors.firstName && <div className="text-danger small">{errors.firstName}</div>}
            </Col>

            <Col md={3} className="mb-2">
              <Label for="firstName">Last Name</Label>
              <Input
                type="text"
                id="lastName"
                value={vendor.lastName}
                onChange={e => handleChange('lastName', e.target.value)}
                invalid={!!errors.lastName}
                placeholder="Vendor Name"
                disabled={!isEditable}
              />
              {errors.lastName && <div className="text-danger small">{errors.lastName}</div>}
            </Col>

            {/* Document Upload */}
            <Col md={3} className="mb-2">
              <Label>Upload Document</Label>
              <div onClick={() => isEditable && triggerUpload()} style={{ cursor: 'pointer' }}>
                <InputGroup
                  style={{
                    borderRadius: '5px',
                    overflow: 'hidden',
                    border: `1px solid ${errors?.documentUrl ? '#dc3545' : '#d1d9e6'}`,
                    height: '40px',
                  }}
                >
                  <Input
                    placeholder={vendor?.documentUrl || 'Upload Document'}
                    disabled
                    style={{
                      backgroundColor: '#f9fafb',
                      color: '#6b7280',
                      border: 'none',
                      pointerEvents: 'none',
                    }}
                    invalid={!!errors.documentUrl}
                  />
                  <InputGroupText
                    style={{
                      backgroundColor: '#f9f9f9',
                      borderLeft: 'none',
                      pointerEvents: 'none',
                      height: '40px',
                    }}
                  >
                    <FiUpload size={18} />
                  </InputGroupText>
                </InputGroup>
              </div>
              <input type="file" accept="application/pdf" ref={fileInputRef} onChange={e => handleFileUpload(e.target.files)} hidden />
              {!!errors.documentUrl && <div className="text-danger small">{errors.documentUrl}</div>}
            </Col>

            {/* Region */}
            <Col md={3} className="mb-2">
              <Label for="region">Region</Label>
              <AsyncPaginate
                debounceTimeout={500}
                value={vendor.region}
                loadOptions={loadOptions}
                onChange={onSelectRegion}
                isMulti={false}
                closeMenuOnSelect
                noOptionsMessage={() => 'No results found'}
                cacheUniqs={[['code']]}
                placeholder=""
                isDisabled={!isEditable}
              />
              {errors.region && <div className="text-danger small">{errors.region}</div>}
            </Col>

            {/* Currency */}
            <Col md={3} className="mb-2">
              <Label for="currency">Currency</Label>
              <Select options={currencyOptions} value={vendor.currency} onChange={e => handleChange('currency', e)} isDisabled={!isEditable} />
              {errors.currency && <div className="text-danger small">{errors.currency}</div>}
            </Col>

            <Col md={3} className="mb-2">
              <Label for="currency">Tax Mode</Label>
              <Select options={taxModeOptions} value={vendor.taxMode} onChange={e => handleChange('taxMode', e)} isDisabled={!isEditable} />
              {errors.taxMode && <div className="text-danger small">{errors.taxMode}</div>}
            </Col>

            <Col md={3} className="mb-2">
              <Label for="currency">Tax Value</Label>
              <Input
                type="number"
                id="taxValue"
                value={vendor.taxValue}
                onChange={e => handleChange('taxValue', e.target.value)}
                invalid={!!errors.taxValue}
                placeholder="Tax Value"
                disabled={!isEditable || vendor?.taxMode === null}
              />{' '}
              {errors.taxValue && <div className="text-danger small">{errors.taxValue}</div>}
            </Col>

            <Col md={3} className="mb-2">
              <Label for="password">Add Password</Label>
              <InputGroup>
                <Input
                  type="text"
                  id="password"
                  value={vendor.password}
                  onChange={e => handleChange('password', e.target.value)}
                  invalid={!!errors.password}
                  placeholder="Enter Password"
                  disabled={true}
                />
                <InputGroupText
                  role="button"
                  className="cursor-pointer"
                  onClick={() => {
                    navigator.clipboard.writeText(vendor.password);
                    cogoToast.success('Password Copied to clipboard');
                  }}
                >
                  <i className=" ri-file-copy-line"></i>
                </InputGroupText>
              </InputGroup>
              {errors.password && <div className="text-danger small">{errors.password}</div>}
            </Col>
          </Row>

          {carTypeList.length > 0 && (
            <>
              <Label>Car Type</Label>
              <div className="d-flex flex-wrap gap-2">
                {carTypeList?.map((type, idx) => {
                  const isSelected = vendor.selectedCarTypes.some(selected => selected.id === type.id);
                  const pillId = `car-type-pill-${idx}`;
                  return (
                    <React.Fragment key={idx}>
                      <div
                        id={pillId} // 👈 unique id
                        onClick={() => handleCarTypeClick(type)}
                        className="p-2 cursor-pointer"
                        style={{
                          borderRadius: '25px',
                          color: '#6F7594',
                          border: isSelected ? '1px solid #405189' : '1px solid #D0D2DC',
                          background: isSelected ? '#ABB9E8' : 'transparent',
                        }}
                      >
                        {type?.name?.split(' ')[0] ?? ''}
                      </div>
                      {/* Tooltip for full name */}
                      <UncontrolledTooltip placement="top" target={pillId}>
                        {type?.name}
                      </UncontrolledTooltip>
                    </React.Fragment>
                  );
                })}
              </div>
              {errors.selectedCarTypes && <div className="text-danger small mt-1">{errors.selectedCarTypes}</div>}
            </>
          )}

          <Card className="mt-3" style={{ background: 'rgba(246, 246, 246, 1)' }}>
            <CardHeader style={{ background: 'rgba(246, 246, 246, 1)' }}>
              <p className="fs-16 fw-semibold m-0">Car Type Configuration</p>
            </CardHeader>
            <CardBody style={{ maxHeight: '318px', overflowY: 'auto' }}>
              <ul className="list-unstyled m-0 p-0" style={{ minWidth: '800px' }}>
                {car.map((item, index) => (
                  <li key={index} className="d-flex align-items-center gap-3 p-2 rounded" style={{ minWidth: 'max-content', whiteSpace: 'nowrap' }}>
                    {/* Car Name */}
                    <div>
                      <Label>Car Name</Label>
                      <Input
                        type="text"
                        value={item.carName}
                        onChange={e => handleChangeForCar(index, 'carName', e.target.value)}
                        placeholder="Car Name"
                      />
                      <div style={{ minHeight: '18px' }}>
                        {carErrors[index]?.carName && <small style={{ color: 'red' }}>{carErrors[index].carName}</small>}
                      </div>
                    </div>

                    {/* Service Type */}
                    <div>
                      <Label>Car Type</Label>
                      <Select
                        options={carTypeOptions}
                        value={item.carType}
                        onChange={selected => handleChangeForCar(index, 'carType', selected)}
                        placeholder="Select"
                        styles={{ container: base => ({ ...base, width: '200px' }) }}
                      />
                      <div style={{ minHeight: '18px' }}>
                        {carErrors[index]?.carType && <small style={{ color: 'red' }}>{carErrors[index].carType}</small>}
                      </div>
                    </div>

                    {/* Passengers */}
                    <div>
                      <Label>No. of Passengers</Label>
                      <Input type="text" value={item?.carType?.data?.numberOfPassengers ?? null} disabled />
                      <div style={{ minHeight: '18px' }}></div>
                    </div>

                    {/* Infant */}
                    <div>
                      <Label>No. of Infant</Label>
                      <Input type="text" value={item?.carType?.data?.numberOfInfants ?? null} disabled />
                      <div style={{ minHeight: '18px' }}></div>
                    </div>

                    {/* Baby Seats */}
                    <div>
                      <Label>No. of Baby Seats</Label>
                      <Input type="text" value={item?.carType?.data?.numberOfBabySeats ?? null} disabled />
                      <div style={{ minHeight: '18px' }}></div>
                    </div>

                    {/* Luggage */}
                    <div>
                      <Label>No. of Luggage</Label>
                      <Input type="text" value={item?.carType?.data?.numberOfLuggages ?? null} disabled />
                      <div style={{ minHeight: '18px' }}></div>
                    </div>

                    {/* Delete Icon */}
                    <div className="d-flex align-items-center">
                      {car.length > 1 && (
                        <Button color="danger" className="mt-1" onClick={() => removeCarType(index)} style={{ padding: '6px 8px' }}>
                          <Trash2 size={18} />
                        </Button>
                      )}
                    </div>
                  </li>
                ))}
              </ul>

              {/* Add New Button */}
              <div>
                <p style={{ color: 'rgba(64, 81, 137, 1)' }} className="text-decoration-underline text-end cursor-pointer" onClick={addNewCarType}>
                  + Add New
                </p>
              </div>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
      <div className="d-flex justify-content-end">
        <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
          Continue
        </Button>
      </div>
    </>
  );
};

export default AddVendor;
